import { render, staticRenderFns } from "./Level.vue?vue&type=template&id=8f838ee4&scoped=true&"
import script from "./Level.vue?vue&type=script&lang=js&"
export * from "./Level.vue?vue&type=script&lang=js&"
import style0 from "./Level.vue?vue&type=style&index=0&id=8f838ee4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f838ee4",
  null
  
)

export default component.exports